import React from 'react';

export default function InviteList() {
    return <div>Invite list</div>
}